const Rule = () => {
  return <hr className="my-2 border-[0.5px] border-gray-400" />;
};

export default Rule;
